export default __webpack_public_path__ + "static/media/be-icon-white.08e46e55.svg";